export const BSCSCAN_ADDRESS_URL = {
  56: "https://bscscan.com/address/",
  97: "https://testnet.bscscan.com/address/",
};

export const PANCAKESWAP_API_URL =
  "https://api.pancakeswap.info/api/v2/tokens/";

export const BINANCE_API_URL =
  "https://api.binance.com/api/v1/ticker/24hr?symbol=";
